import { getIdFromToken } from "./get-id-from-token";
var faqTokenRegex = /\[faq\|[0-9a-z\-]+\]/mgi;
export var replaceFaqTokens = function (supportPageUrl, sku, text, generateUrl) {
    faqTokenRegex.lastIndex = 0;
    var tokens = text === null || text === void 0 ? void 0 : text.match(faqTokenRegex);
    if (!tokens) {
        return text;
    }
    var tokenIds = tokens.map(getIdFromToken);
    var augmentedText = text;
    tokenIds.forEach(function (tokenId) {
        augmentedText = augmentedText.replace("[FAQ|" + tokenId + "]", generateUrl(supportPageUrl, sku, tokenId));
    });
    return augmentedText;
};
